import { Input } from 'reactstrap';
import { Link } from 'react-router-dom';
import React from 'react';
import { formatDate } from '../../helpers';

export const columnFilter = ({ onChange }) => (
  <Input
    onChange={(event) => onChange(event.target.value)}
    style={{ width: '100%' }}
    placeholder='Search'
  />
);

export const convertAdditionalData = (cell) => {
  const submission = cell && cell.value ? JSON.parse(cell.value) : null;
  return <span>{submission ? submission.countSoftReject : ''}</span>;
};

export const dateFormatter = (cell) => {
  const date = cell && cell.value ? cell.value : null;
  return <span>{date ? formatDate(date) : 'n/a'}</span>;
};

export const linkFormatter = (cell) => {
  const submission = cell && cell.value ? cell.value : null;
  return (
    <span>
      <Link to={submission ? `/submission/${submission}` : ''}>VIEW</Link>{' '}
    </span>
  );
};

export const myReviewslinkFormatter = (cell) => {
  const cellValid = cell && cell.value;
  const submission = cellValid ? cell.value : null;
  const reviewingId = cellValid ? cell.original.id : null;
  return (
    <span>
      <Link
        to={
          submission && reviewingId
            ? `/submission/${submission}?reviewingId=${reviewingId}`
            : ''
        }
      >
        VIEW
      </Link>{' '}
    </span>
  );
};

export const capitalize = (cell) => {
  const submissionResult =
    cell && cell.value
      ? cell.value.charAt(0).toUpperCase() + cell.value.slice(1)
      : 'n/a';
  return <span>{submissionResult}</span>;
};
